// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.paypal img {
  height: auto;
  max-width: 100%;
  cursor: pointer;
}

.btn-primary.btn-outline {
  color: #fff;
}

.cart-product-imitation {
  padding-top: 0;
  overflow: hidden;
}
.cart-product-imitation img {
  width: 100%;
  height: auto;
}

#price {
  margin: 10px 0 0;
}

input#check {
  margin: 0 0 10px 0;
}

input#check:focus {
  outline: 0 none;
  border: 1px solid rgb(105, 190, 40);
}

h5.add-new-card {
  cursor: pointer;
}

input.coupon-code {
  height: 32px;
  padding: 3px 7px;
  display: inline-block;
  line-height: normal;
  border-radius: 3px;
  font-size: 13px;
  border: 1px solid #d0d0d0;
  border-top: 1px solid #bbb;
  width: 15em !important;
  margin-right: 5px;
}
input.coupon-code:focus-visible, input.coupon-code:focus {
  outline: none;
}

.discount-form {
  margin: 20px;
}

.discount-code {
  color: rgb(105, 190, 40);
  font-size: 15px;
  font-weight: 500;
}
.discount-code .fa {
  padding-left: 2px;
  color: #a5a6a9;
  cursor: pointer;
}

.item-link {
  cursor: pointer;
}

.label-shipping {
  width: 100%;
  display: block;
  clear: both;
  margin: 0;
  padding: 10px 0px;
  line-height: 1 !important;
  vertical-align: top;
  font-weight: normal;
}
.label-shipping:first-child {
  padding-top: 15px;
}
.label-shipping:last-child {
  padding-bottom: 15px;
}

.label-shipping input {
  display: inline-block !important;
  width: auto !important;
  vertical-align: top !important;
  margin: 0 !important;
  line-height: normal;
  height: auto !important;
}

.ibox-content.margin-input .form-control {
  margin-bottom: 15px;
}

/* iCheck plugin Square skin, green
----------------------------------- */
::ng-deep .ibox-content {
  /* HiDPI support */
}
::ng-deep .ibox-content .icheckbox_square-green,
::ng-deep .ibox-content .iradio_square-green {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 22px;
  height: 22px;
  background: url("https://assets.foursightonline.com/app/images/green.png") no-repeat;
  border: none;
  cursor: pointer;
}
::ng-deep .ibox-content .icheckbox_square-green {
  background-position: 0 0;
}
::ng-deep .ibox-content .icheckbox_square-green.hover {
  background-position: -24px 0;
}
::ng-deep .ibox-content .icheckbox_square-green.checked {
  background-position: -48px 0;
}
::ng-deep .ibox-content .icheckbox_square-green.disabled {
  background-position: -72px 0;
  cursor: default;
}
::ng-deep .ibox-content .icheckbox_square-green.checked.disabled {
  background-position: -96px 0;
}
::ng-deep .ibox-content .iradio_square-green {
  background-position: -120px 0;
}
::ng-deep .ibox-content .iradio_square-green.hover {
  background-position: -144px 0;
}
::ng-deep .ibox-content .iradio_square-green.checked {
  background-position: -168px 0;
}
::ng-deep .ibox-content .iradio_square-green.disabled {
  background-position: -192px 0;
  cursor: default;
}
::ng-deep .ibox-content .iradio_square-green.checked.disabled {
  background-position: -216px 0;
}
@media (min-resolution: 120dpi) {
  ::ng-deep .ibox-content .icheckbox_square-green,
  ::ng-deep .ibox-content .iradio_square-green {
    background-image: url("https://assets.foursightonline.com/app/images/green@2x.png");
    background-size: 240px 24px;
  }
}

span.d-inline {
  display: inline-block;
  vertical-align: middle;
  padding-right: 15px;
  font-size: 14px !important;
}
span.d-inline input {
  display: inline-block;
  width: 70px;
  font: inherit;
}
span.d-inline input:focus-visible {
  outline: none;
}
span.d-inline input:focus {
  border: 1px solid #1ab394;
}
span.d-inline h4 {
  display: inline-block;
  margin-top: 0;
  margin-bottom: 0;
}
span.d-inline:last-child {
  padding-right: 0;
}

.shoping-cart-table td:last-child {
  width: 150px;
}

.ibox-title.bottom-border {
  padding-left: 0;
  padding-right: 0;
  border-top: 0;
  padding-top: 0;
  min-height: inherit;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}

.ibox-main select,
.ibox-main input {
  margin-bottom: 10px;
  margin-top: 2px;
}

.d-flex {
  display: flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  align-items: flex-end;
  -webkit-align-items: flex-end;
  -moz-align-items: flex-end;
  width: 100%;
}

.d-flex-center {
  display: flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  align-items: center;
  -webkit-align-items: center;
  -moz-align-items: center;
}

.btn-top-bar {
  text-align: right;
}

@media screen and (max-width: 597px) {
  .btn-top-bar {
    margin-top: 15px;
    text-align: left;
  }
}
table.shoping-cart-table tr .desc {
  width: 56%;
  white-space: normal;
}
@media screen and (max-width: 640px) {
  table.shoping-cart-table tr .desc {
    white-space: nowrap;
  }
}
table.shoping-cart-table tr .img-td {
  width: 14%;
}
table.shoping-cart-table tr .prc,
table.shoping-cart-table tr .qty,
table.shoping-cart-table tr .tlp {
  width: 10%;
  white-space: nowrap;
  text-align: center;
}
table.shoping-cart-table tr .tlp {
  text-align: right;
}
table.shoping-cart-table tr td.qty {
  padding-top: 0;
}

.content-table {
  padding: 15px 20px 0 20px;
  background-color: #fff;
}

.shoping-cart-table.top-heading-table th {
  border-bottom: 0;
}

::ng-deep.box-shadow-cart {
  box-shadow: 0 0 10px -5px #000;
  border-color: #e2e2e2;
}
::ng-deep.box-shadow-cart .bottom-cart {
  box-shadow: none;
}

.shipping-inline {
  display: table;
  width: 100%;
}
.shipping-inline .label-shipping {
  display: block;
  vertical-align: top;
  padding-right: 10px;
  width: auto !important;
}
.shipping-inline .label-shipping:first-child {
  padding-top: 10px;
}

.item-checkbox input[type=checkbox] {
  margin-right: 5px;
  margin-bottom: 5px;
  vertical-align: middle;
}

.address-item .fa-pencil {
  cursor: pointer;
}

.edit-address-form label {
  margin-bottom: 0;
  font-weight: 700;
}

.main-card {
  position: relative;
  padding: 30px;
  width: 100%;
  margin: 0 auto;
}
.main-card input:focus {
  outline: none;
}

.slds-form--compound .slds-form-element,
.slds-form_compound .slds-form-element {
  width: 100%;
}

.slds-form-element {
  position: relative;
}

.slds-form--compound .slds-form-element__row,
.slds-form_compound .slds-form-element__row {
  display: flex;
  margin-bottom: 0.5rem;
}

.slds-form--compound .slds-form-element,
.slds-form_compound .slds-form-element {
  width: 100%;
}

.slds-input,
.slds-button {
  border-radius: 0;
}

.slds-input {
  background-color: #fff;
  color: #16325c;
  border: 1px solid #d8dde6;
  border-radius: 0.25rem;
  width: 100%;
  transition: border 0.1s linear, background-color 0.1s linear;
  display: inline-block;
  padding: 0 1rem 0 0.75rem;
  line-height: 2.875rem;
  min-height: calc(1.875rem + 2px);
}

.slds-form--compound .slds-form-element__row + .slds-form-element__row,
.slds-form_compound .slds-form-element__row + .slds-form-element__row {
  clear: both;
}

.slds-size--1-of-2,
.slds-size_1-of-2 {
  width: 50%;
}

.slds-size--1-of-1,
.slds-size_1-of-1 {
  width: 100%;
}

.slds-button {
  -webkit-appearance: button;
  cursor: pointer;
}

.slds-button {
  position: relative;
  display: inline-block;
  padding: 0;
  background: 0 0;
  background-clip: border-box;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  font-size: 1.2rem;
  line-height: 2.875rem;
  text-decoration: none;
  color: #0070d2;
  -webkit-appearance: none;
  white-space: normal;
  -webkit-user-select: none;
  user-select: none;
  transition: color 50ms linear, background-color 50ms linear;
}

.slds-button--brand,
.slds-button_brand {
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
  vertical-align: middle;
  background-color: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
  color: #fff;
}

.mt-card {
  margin-top: 15px;
}

.bottom-cart select,
.bottom-cart input {
  margin-bottom: 16px;
  margin-top: 1px;
  min-height: 34px;
}
.bottom-cart select:focus-visible,
.bottom-cart input:focus-visible {
  outline: none;
}
.bottom-cart select:focus,
.bottom-cart input:focus {
  border: 1px solid #1ab394;
}

.jp-card {
  min-width: inherit;
}

@media screen and (max-width: 1199px) {
  .main-card {
    justify-content: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
  }
  .pd-top-card {
    padding-top: 25px;
  }
}
@media screen and (max-width: 640px) {
  .shipping-inline {
    display: block;
  }
  .shipping-inline label {
    display: block;
  }
}
@media screen and (max-width: 480px) {
  ::ng-deep.jp-card-container {
    width: 100% !important;
    margin-bottom: 10px;
    transform: none !important;
  }
  ::ng-deep.jp-card {
    min-width: inherit !important;
    max-width: 400px;
  }
  .main-card {
    padding: 15px;
    display: block;
  }
  .item-checkbox {
    float: left;
    text-align: left;
    clear: both;
  }
}
.address-mb {
  margin-top: 15px;
  margin-bottom: 15px;
}

.ibox-title.pdts {
  border-bottom: 1px solid #ddd;
}

.address-form {
  padding-top: 25px;
  padding-left: 15px;
  padding-right: 15px;
}

.ship-methods,
.card-payment {
  min-height: 150px;
  left: 0 !important;
  top: 0 !important;
  position: relative;
}

.ibox-title h5 {
  cursor: pointer;
}

.main-wrapper {
  margin-bottom: 30px;
}

.submain-wrapper {
  margin-bottom: 20px;
}

.billing-lables {
  display: block;
  width: 100%;
}
.billing-lables label {
  display: inline-block;
  vertical-align: middle;
  font-weight: normal;
  padding-right: 10px;
}
.billing-lables input {
  vertical-align: middle;
  display: inline-block;
  width: auto;
  height: auto;
}

.address-item {
  padding-top: 15px;
  padding-bottom: 15px;
}
.address-item ul {
  padding: 0;
  margin-left: 0;
  margin-bottom: 15px;
}

.add-shipping {
  display: inline-block;
  padding: 15px;
  cursor: pointer;
  background-color: #fff;
  border: 1px dotted #ddd;
  box-shadow: 0 2px 0 #ddd;
  white-space: wrap;
  zoom: 1;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
  margin: 0;
  padding: 0;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  padding: 5px 10px 0px;
  font-size: 14px;
  line-height: 1.3;
}
.add-shipping:hover {
  border: 1px solid #ccc;
}
.add-shipping i {
  font-size: 20px;
  padding: 0 15px 0 0;
  float: left;
}
.add-shipping span {
  overflow: hidden;
  display: inherit;
  display: block;
}

.address-item .btn {
  font-size: 12px;
}

.mb-same-billing {
  margin-bottom: 10px;
}
.mb-same-billing label {
  cursor: pointer;
}

.billing-box {
  display: flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  margin-bottom: 20px;
}
@media screen and (max-width: 767px) {
  .billing-box {
    display: block;
  }
}

.saved-cards-wrap {
  padding-top: 25px;
  padding-left: 15px;
  padding-right: 15px;
}
@media screen and (max-width: 767px) {
  .saved-cards-wrap div[class*=col-]:nth-child(2) {
    padding-top: 20px;
  }
}

.saved-card-list li label {
  padding-left: 15px;
  padding-right: 10px;
  cursor: pointer;
}
.saved-card-list li i {
  cursor: pointer;
}

.new-card label {
  padding-left: 15px;
}

.label-shipping input {
  float: left;
  margin-top: 4px !important;
}
.label-shipping label {
  float: left;
  padding-left: 10px;
  width: 80%;
  cursor: pointer;
  font-weight: normal;
  line-height: 1.6;
}

.order-info {
  font-weight: normal;
  font-style: italic;
}

.list-ship-adrs {
  display: block;
  width: 100%;
  position: relative;
  padding-left: 24px;
}
.list-ship-adrs input[type=radio] {
  display: inline-block;
  width: auto;
  vertical-align: top;
  height: auto;
  margin-top: 5px;
  position: absolute;
  left: 0;
  top: 0;
  min-height: inherit;
}
.list-ship-adrs label {
  display: inline;
  padding-left: 0;
  cursor: pointer;
  vertical-align: middle;
}
@media screen and (max-width: 540px) {
  .list-ship-adrs label {
    vertical-align: top;
    width: 80%;
  }
}
.list-ship-adrs label span {
  vertical-align: middle;
}
.list-ship-adrs a,
.list-ship-adrs span {
  vertical-align: middle;
}

.bill-adrs {
  margin-bottom: 15px;
}

.label-shipAdrs {
  font-weight: 400 !important;
}

.list-bold {
  font-weight: bold;
}

.btn-address {
  background-color: #6d6e71;
  color: white;
  opacity: 0.6;
}

.btn-address.active {
  background-color: rgb(105, 190, 40);
  opacity: 1;
}

::ng-deep.swal2-modal {
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}

::ng-deep .swal2-show {
  background-color: white;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 478px;
  padding: 17px;
  border-radius: 5px;
  text-align: center;
  position: fixed;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: -256px;
  overflow: hidden;
  z-index: 99999;
  margin-top: -168px;
}
::ng-deep .swal2-show:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled {
  background-color: #D0D0D0 !important;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled {
  background-color: #AEDEF4;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled:focus {
  outline: none;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning {
  width: 80px;
  height: 80px;
  border: 4px solid gray;
  border-radius: 40px;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  border-color: #F8BB86;
  font-size: 58px;
  color: #F8BB86;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning:focus {
  outline: none;
}
::ng-deep .swal2-show h2#swal2-title {
  color: #575757;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 25px 0;
  padding: 0;
  line-height: 40px;
  display: block;
}
::ng-deep .swal2-show h2#swal2-title:focus {
  outline: none;
}
::ng-deep .swal2-show div#swal2-content {
  color: #797979;
  font-size: 16px;
  text-align: center;
  font-weight: 300;
  position: relative;
  text-align: inherit;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
}
::ng-deep .swal2-show div#swal2-content:focus {
  outline: none;
}

::ng-deep .swal2-shown {
  background-color: black;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
}

::ng-deep.swal2-modal {
  max-width: 500px !important;
  width: 100% !important;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
  box-sizing: border-box !important;
  bottom: 0;
  right: 0;
  margin: auto !important;
  height: 390px;
}

@media screen and (max-width: 380px) {
  ::ng-deep.swal2-modal {
    height: inherit;
  }
}
::ng-deep.swal2-icon-text {
  font-size: 1.3em;
  line-height: 1;
}

.fade-div {
  opacity: 0.4;
}

.list-group .pull-left {
  font-family: "Museo-300";
  font-size: 15px;
  padding: 5px 0px;
  width: 60%;
}
.list-group .pull-left--bold {
  font-family: "Museo-700" !important;
}
.list-group .pull-right {
  font-size: 2em;
}
.list-group .pull-right--bold {
  font-family: "Museo-700" !important;
}

.list-group.clear-list .list-group-item.fist-item {
  border-top: 1px solid #aaa;
  border-bottom: 0;
  border-right: 0;
  border-left: 0;
  padding: 10px 0;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

li.list-group-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
li.list-group-item--discount {
  margin-bottom: 50px !important;
}
li.list-group-item--none {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none !important;
}
li.list-group-item--total {
  border-bottom: 1px solid #aaa !important;
}

.amount-span {
  white-space: nowrap;
  word-break: normal !important;
  max-width: inherit;
  width: 40%;
  text-align: right;
  font-size: 1em !important;
  font-family: "Museo-300" !important;
}
.amount-span--bold {
  font-family: "Museo-700" !important;
}

.d-inline {
  display: inline-block;
}

.prod-options .btn-primary {
  display: inline-block;
}

.complimentary-item {
  position: relative;
  padding-top: 8px;
}

.red-text {
  color: red;
}

.error-msg {
  font-size: 14px;
}

.payment-grid {
  position: relative;
}

.fixed-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
}

.main-card {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.assessment-title h2 {
  margin-top: 0;
  font-weight: 500;
  font-size: 15px;
  line-height: 1.3;
  margin-bottom: 0;
}

#stripe_error {
  color: #f00;
}

#card_error {
  display: none;
  color: white;
  background-color: red;
  padding: 10px;
}

#stripe_card {
  background: #f2f2f2;
  padding: 20px;
  margin-bottom: 5px !important;
  border-radius: 2px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.ship-methods {
  padding: 15px;
}

.list-summary {
  clear: both;
  display: block;
}

.ship-methods-heading {
  padding-left: 14px;
}

.billing-header {
  margin-top: 20px;
  margin-bottom: 0 !important;
}

.summary-product-name {
  font-size: 13px;
  display: block;
  margin: 2px 0 5px 0;
}

.top-cart h5 {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}

.summary-product-quantity {
  font-size: 13px;
  display: block;
}

/*@media screen and (min-width:1101px) and (max-width:1300px){
    .amount-span{
        font-size: 1.5em !important;
    }
}
@media screen and (min-width:992px) and (max-width:1100px){
.amount-span{
        font-size: 1.2em !important;
}   
}
@media screen and (max-width:575px){
 .amount-span{
        font-size: 1.2em !important;
}      
}*/
.span12 {
  padding-top: 15px;
}

.billing-details {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
}
@media screen and (max-width: 400px) {
  .billing-details {
    display: block;
  }
}
.billing-details h5 {
  margin-top: 3px;
}

.billing-details .item-checkbox {
  padding-left: 10px;
}
@media screen and (max-width: 400px) {
  .billing-details .item-checkbox {
    padding-left: 0;
  }
}

@media screen and (max-width: 767px) {
  .shipping-adrs .address-form {
    padding-top: 0 !important;
  }
  .shipping-adrs.bottom-cart {
    padding-top: 0 !important;
  }
}
.empty-cart {
  padding: 17px;
  font-size: 2rem;
  font-weight: 600;
}
.empty-cart a {
  margin-left: 10px;
}

/*modal tab*/
.tab {
  display: table;
  width: 100%;
  padding-left: 0px;
  margin-bottom: 0;
  border: 1px solid #ddd;
  text-align: center;
}
.tab li {
  display: table-cell;
  padding: 5px 10px;
  cursor: pointer;
  font-weight: 600;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.07);
}
.tab li.active-block {
  background-color: #fff;
}
.tab li + li {
  border-left: 1px solid #ddd;
}
.tab li img {
  margin-right: 5px;
  vertical-align: middle;
}

.note-block {
  margin-top: 20px;
  background: #f5f5f5;
  padding: 15px;
}
.note-block strong {
  font-size: 16px;
  margin-bottom: 10px;
  display: inline-block;
}
.note-block ol {
  padding-left: 25px !important;
}
.note-block ol li + li {
  margin-top: 10px;
}

.tab-content .tab-content-inner {
  padding-top: 20px;
}
.tab-content .pt-2 {
  padding-top: 20px;
}
.tab-content h2 {
  margin: 0 0 5px;
  line-height: 32px;
  font-size: 20px;
  font-weight: 400;
}
.tab-content ol {
  padding-left: 15px;
}
.tab-content .orange-btn {
  padding: 12px 20px;
  background-color: rgb(226, 95, 31);
  color: #fff;
  text-transform: capitalize;
  display: inline-block;
  border-radius: 3px;
}

.modal-body {
  padding-top: 30px;
}
.modal-body button.close {
  position: absolute;
  right: 10px;
  top: 10px;
}

::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}

.tooltipicon {
  position: relative;
  cursor: pointer;
  font-size: 11px;
}

.tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: #676a6c;
  text-align: left;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  line-height: 1.2em;
  /* Position the tooltip */
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
@media screen and (max-width: 1199px) {
  .tooltipicon .tooltiptext {
    left: auto;
    right: 10px;
  }
}

.tooltipicon:hover .tooltiptext {
  visibility: visible;
}

.bottom-card {
  align-items: center;
  justify-content: space-between;
}

.ibox-title h5 {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}

button.close {
  z-index: 999999;
}

.grey-out {
  background: #676a6c;
  border-color: #676a6c;
  opacity: 0.5;
}

::ng-deep.card-payment {
  z-index: 99999999 !important;
}
::ng-deep.card-payment .modal-dialog {
  max-width: 400px !important;
}
::ng-deep.card-payment .modal-dialog .modal-body {
  padding: 0 !important;
}

.proceed-ship-method {
  padding: 10px;
}

.sr-form-row label {
  padding-top: 5px;
  margin-bottom: 0;
  font-weight: 700;
  padding-left: 22px;
}
.sr-form-row label input {
  top: 8px;
  left: 0;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100%;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.table-responsive table {
  margin-bottom: 0;
}
.table-responsive tr td {
  border: 0;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body {
  padding: 20px 30px 30px 30px;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .table-responsive table {
  line-height: 20px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .table-responsive table th {
  text-align: left;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form ul {
  margin-top: 0;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group {
  padding-left: 0;
  margin-bottom: 20px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group-item.active, ::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group-item.active:hover, ::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group-item.active:focus {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  border-radius: 4px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .lbl {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .btn-r .f-btn {
  padding: 5px 10px;
  line-height: 1.5;
  font-size: 12px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .btn-r .f-btn--info {
  background-color: #1dc5a3;
  border-color: #1dc5a3;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body.no-pad {
  padding: 0;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}
::ng-deep .modal .hidden {
  display: none;
}

::ng-deep.modal-open {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/store-cart/store-cart.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA1YA;EACE,YAAA;EACA,eAAA;EACA,eAAA;AA6YF;;AA1YA;EACE,WAAA;AA6YF;;AA1YA;EACE,cAAA;EACA,gBAAA;AA6YF;AA3YE;EACE,WAAA;EACA,YAAA;AA6YJ;;AAzYA;EACE,gBAAA;AA4YF;;AAxYA;EACE,kBAAA;AA2YF;;AAxYA;EACE,eAAA;EACA,mCAAA;AA2YF;;AAxYA;EACE,eAAA;AA2YF;;AAxYA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,iBAAA;AA2YF;AAzYE;EAEE,aAAA;AA0YJ;;AAtYA;EACE,YAAA;AAyYF;;AAtYA;EACE,wBD1Cc;EC2Cd,eAAA;EACA,gBAAA;AAyYF;AAvYE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAyYJ;;AArYA;EACE,eAAA;AAwYF;;AArYA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAwYF;AAtYE;EACE,iBAAA;AAwYJ;AArYE;EACE,oBAAA;AAuYJ;;AAnYA;EACE,gCAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAsYF;;AAjYI;EACE,mBAAA;AAoYN;;AA/XA;qCAAA;AAEA;EA2DE,kBAAA;AAwUF;AAhYE;;EAEE,qBAAA;GAkYF,eAjYE;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oFAAA;EACA,YAAA;EACA,eAAA;AAkYJ;AA/XE;EACE,wBAAA;AAiYJ;AA9XE;EACE,4BAAA;AAgYJ;AA7XE;EACE,4BAAA;AA+XJ;AA5XE;EACE,4BAAA;EACA,eAAA;AA8XJ;AA3XE;EACE,4BAAA;AA6XJ;AA1XE;EACE,6BAAA;AA4XJ;AAzXE;EACE,6BAAA;AA2XJ;AAxXE;EACE,6BAAA;AA0XJ;AAvXE;EACE,6BAAA;EACA,eAAA;AAyXJ;AAtXE;EACE,6BAAA;AAwXJ;AApXE;EAIE;;IAEE,mFAAA;IAEA,2BAAA;EAmXJ;AACF;;AA/WA;EACE,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAkXF;AAhXE;EACE,qBAAA;EACA,WAAA;EACA,aAAA;AAkXJ;AAhXI;EACE,aAAA;AAkXN;AA/WI;EACE,yBAAA;AAiXN;AA7WE;EACE,qBAAA;EACA,aAAA;EACA,gBAAA;AA+WJ;AA5WE;EACE,gBAAA;AA8WJ;;AAxWI;EACE,YAAA;AA2WN;;AAtWA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AAyWF;;AApWE;;EAEE,mBAAA;EACA,eAAA;AAuWJ;;AAnWA;EAKE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,6BAAA;EACA,0BAAA;EACA,WAAA;AAsWF;;AAnWA;EAKE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;AAsWF;;AAnWA;EACE,iBAAA;AAsWF;;AAnWA;EACE;IACE,gBAAA;IACA,gBAAA;EAsWF;AACF;AAhWI;EACE,UAAA;EACA,mBAAA;AAkWN;AAhWM;EAJF;IAKI,mBAAA;EAmWN;AACF;AA/VI;EACE,UAAA;AAiWN;AA9VI;;;EAGE,UAAA;EACA,mBAAA;EACA,kBAAA;AAgWN;AA7VI;EACE,iBAAA;AA+VN;AA5VI;EACE,cAAA;AA8VN;;AAxVA;EACE,yBAAA;EACA,sBAAA;AA2VF;;AAvVE;EACE,gBAAA;AA0VJ;;AAtVA;EACE,8BAAA;EACA,qBAAA;AAyVF;AAvVE;EACE,gBAAA;AAyVJ;;AArVA;EACE,cAAA;EACA,WAAA;AAwVF;AAtVE;EACE,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAwVJ;AAtVI;EACE,iBAAA;AAwVN;;AAlVE;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;AAqVJ;;AAhVE;EACE,eAAA;AAmVJ;;AA9UE;EACE,gBAAA;EACA,gBAAA;AAiVJ;;AA1UA;EAEE,kBAAA;EACA,aAAA;EAEA,WAAA;EACA,cAAA;AA2UF;AAzUE;EACE,aAAA;AA2UJ;;AAvUA;;EAEE,WAAA;AA0UF;;AAvUA;EACE,kBAAA;AA0UF;;AAvUA;;EAGE,aAAA;EACA,qBAAA;AA0UF;;AAvUA;;EAEE,WAAA;AA0UF;;AAvUA;;EAEE,gBAAA;AA0UF;;AAvUA;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,4DAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gCAAA;AA0UF;;AAvUA;;EAEE,WAAA;AA0UF;;AAvUA;;EAEE,UAAA;AA0UF;;AAvUA;;EAEE,WAAA;AA0UF;;AAvUA;EACE,0BAAA;EACA,eAAA;AA0UF;;AAvUA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,2DAAA;AA0UF;;AAvUA;;EAEE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mCD7cc;EC8cd,mCAAA;EACA,WAAA;AA0UF;;AAvUA;EACE,gBAAA;AA0UF;;AAvUA;;EAEE,mBAAA;EACA,eAAA;EACA,gBAAA;AA0UF;AAxUE;;EACE,aAAA;AA2UJ;AAxUE;;EACE,yBAAA;AA2UJ;;AAvUA;EACE,kBAAA;AA0UF;;AAvUA;EACE;IACE,uBAAA;IACA,+BAAA;IACA,4BAAA;EA0UF;EAvUA;IACE,iBAAA;EAyUF;AACF;AAtUA;EACE;IACE,cAAA;EAwUF;EAtUE;IACE,cAAA;EAwUJ;AACF;AApUA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,0BAAA;EAsUF;EAnUA;IACE,6BAAA;IACA,gBAAA;EAqUF;EAlUA;IACE,aAAA;IACA,cAAA;EAoUF;EAjUA;IACE,WAAA;IACA,gBAAA;IACA,WAAA;EAmUF;AACF;AAhUA;EACE,gBAAA;EACA,mBAAA;AAkUF;;AA/TA;EACE,6BAAA;AAkUF;;AA/TA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAkUF;;AA/TA;;EAEE,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAkUF;;AA/TA;EACE,eAAA;AAkUF;;AA/TA;EACE,mBAAA;AAkUF;;AA/TA;EACE,mBAAA;AAkUF;;AA/TA;EACE,cAAA;EACA,WAAA;AAkUF;AAhUE;EACE,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAkUJ;AA/TE;EACE,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAiUJ;;AA7TA;EACE,iBAAA;EACA,oBAAA;AAgUF;AA9TE;EACE,UAAA;EACA,cAAA;EACA,mBAAA;AAgUJ;;AA5TA;EACE,qBAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EAGA,wBAAA;EACA,iBAAA;EACA,OAAA;EAGA,yBAAA;EACA,oBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AA+TF;AA7TE;EACE,sBAAA;AA+TJ;AA5TE;EACE,eAAA;EACA,mBAAA;EACA,WAAA;AA8TJ;AA3TE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AA6TJ;;AAxTE;EACE,eAAA;AA2TJ;;AAvTA;EACE,mBAAA;AA0TF;AAxTE;EACE,eAAA;AA0TJ;;AAtTA;EAIE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;AAyTF;AAvTE;EAVF;IAWI,cAAA;EA0TF;AACF;;AAvTA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AA0TF;AAxTE;EACE;IACE,iBAAA;EA0TJ;AACF;;AArTE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;AAwTJ;AArTE;EACE,eAAA;AAuTJ;;AAlTE;EACE,kBAAA;AAqTJ;;AAhTE;EACE,WAAA;EACA,0BAAA;AAmTJ;AAhTE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAkTJ;;AA9SA;EACE,mBAAA;EACA,kBAAA;AAiTF;;AA9SA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAiTF;AA/SE;EACE,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;AAiTJ;AA9SE;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAgTJ;AA9SI;EANF;IAOI,mBAAA;IACA,UAAA;EAiTJ;AACF;AA/SI;EACE,sBAAA;AAiTN;AA7SE;;EAEE,sBAAA;AA+SJ;;AA3SA;EACE,mBAAA;AA8SF;;AA3SA;EACE,2BAAA;AA8SF;;AA3SA;EACE,iBAAA;AA8SF;;AA3SA;EACE,yBDtvBmB;ECuvBnB,YAAA;EACA,YAAA;AA8SF;;AA3SA;EACE,mCD7wBc;EC8wBd,UAAA;AA8SF;;AA1SA;EACE,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AA6SF;;AA1SA;EACE,uBAAA;EACA,wEAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA6SF;AA3SE;EACE,aAAA;AA6SJ;AA1SE;EACE,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA4SJ;AA1SI;EACE,aAAA;AA4SN;AAxSE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA0SJ;AAxSI;EACE,aAAA;AA0SN;AAtSE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AAwSJ;AAtSI;EACE,aAAA;AAwSN;AApSE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAsSJ;AApSI;EACE,aAAA;AAsSN;AAlSE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAoSJ;AAlSI;EACE,aAAA;AAoSN;;AA/RA;EACE,uBAAA;EACA,iEAAA;EACA,oCAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;AAkSF;;AA/RA;EACE,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,aAAA;AAkSF;;AA/RA;EACE;IACE,eAAA;EAkSF;AACF;AA/RA;EACE,gBAAA;EACA,cAAA;AAiSF;;AA9RA;EACE,YAAA;AAiSF;;AA7RE;EACE,wBDl9BO;ECm9BP,eAAA;EACA,gBAAA;EACA,UAAA;AAgSJ;AA9RI;EACE,mCAAA;AAgSN;AA5RE;EACE,cAAA;AA8RJ;AA5RI;EACE,mCAAA;AA8RN;;AAxRA;EACE,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EAGA,aAAA;EAGA,8BAAA;AA2RF;;AAxRA;EAGE,aAAA;EAEA,eAAA;EACA,mBAAA;AA2RF;AAzRE;EACE,8BAAA;AA2RJ;AAxRE;EAGE,aAAA;EAEA,eAAA;EACA,mBAAA;EACA,2BAAA;AA0RJ;AAvRE;EACE,wCAAA;AAyRJ;;AArRA;EACE,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EACA,mCAAA;AAwRF;AAtRE;EACE,mCAAA;AAwRJ;;AApRA;EACE,qBAAA;AAuRF;;AAnRE;EACE,qBAAA;AAsRJ;;AAlRA;EACE,kBAAA;EACA,gBAAA;AAqRF;;AAlRA;EACE,UAAA;AAqRF;;AAlRA;EACE,eAAA;AAqRF;;AAlRA;EACE,kBAAA;AAqRF;;AAlRA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;AAqRF;;AAlRA;EACE,yBAAA;EACA,4BAAA;AAqRF;;AAlRA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAqRF;;AAlRA;EACE,WAAA;AAqRF;;AAlRA;EACE,aAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;AAqRF;;AAlRA;EACE,mBAAA;EACA,aAAA;EAEA,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AAoRF;;AAjRA;EACE,aAAA;AAoRF;;AAjRA;EACE,WAAA;EACA,cAAA;AAoRF;;AAjRA;EACE,kBAAA;AAoRF;;AAjRA;EACE,gBAAA;EACA,2BAAA;AAoRF;;AAjRA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAoRF;;AAjRA;EDh+BE,mCAAA;EACA,8BAAA;ACqvCF;;AAlRA;EACE,eAAA;EACA,cAAA;AAqRF;;AAlRA;;;;;;;;;;;;;;EAAA;AAgBA;EACE,iBAAA;AAoRF;;AAjRA;EAGE,aAAA;EAEA,eAAA;EACA,iBAAA;AAoRF;AAlRE;EARF;IASI,cAAA;EAqRF;AACF;AAnRE;EACE,eAAA;AAqRJ;;AAjRA;EACE,kBAAA;AAoRF;AAlRE;EAHF;IAII,eAAA;EAqRF;AACF;;AAlRA;EACE;IACE,yBAAA;EAqRF;EAlRA;IACE,yBAAA;EAoRF;AACF;AAjRA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAmRF;AAjRE;EACE,iBAAA;AAmRJ;;AA9QA,YAAA;AACA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAiRF;AA/QE;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,qCAAA;AAiRJ;AA/QI;EACE,sBAAA;AAiRN;AA9QI;EACE,2BAAA;AAgRN;AA7QI;EACE,iBAAA;EACA,sBAAA;AA+QN;;AA1QA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;AA6QF;AA3QE;EACE,eAAA;EACA,mBAAA;EACA,qBAAA;AA6QJ;AA1QE;EACE,6BAAA;AA4QJ;AA1QI;EACE,gBAAA;AA4QN;;AAtQE;EACE,iBAAA;AAyQJ;AAtQE;EACE,iBAAA;AAwQJ;AArQE;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAuQJ;AApQE;EACE,kBAAA;AAsQJ;AAnQE;EACE,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;AAqQJ;;AAjQA;EACE,iBAAA;AAoQF;AAlQE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAoQJ;;AA/PA;EACE,oCAAA;AAkQF;;AA9PA;EACE,kBAAA;EACA,eAAA;EAEA,eAAA;AAgQF;;AA7PA;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAgQF;AA9PE;EAlBF;IAmBI,UAAA;IACA,WAAA;EAiQF;AACF;;AA9PA;EACE,mBAAA;AAiQF;;AA9PA;EAIE,mBAAA;EAGA,8BAAA;AAgQF;;AA7PA;ED1rCE,mCAAA;EACA,8BAAA;AC27CF;;AA9PA;EACE,eAAA;AAiQF;;AA9PA;EACE,mBDj0CmB;ECk0CnB,qBDl0CmB;ECm0CnB,YAAA;AAiQF;;AA9PA;EACE,4BAAA;AAiQF;AA/PE;EACE,2BAAA;AAiQJ;AA/PI;EACE,qBAAA;AAiQN;;AA1PA;EACE,aAAA;AA6PF;;AAxPE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA2PJ;AAzPI;EACE,QAAA;EACA,OAAA;AA2PN;;AAtPA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAyPF;;AAtPA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAyPF;;AAtPA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAyPF;;AArPA;EACE,mCAAA;EACA,UAAA;AAwPF;;AArPA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAwPF;;AArPA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AAwPF;;AArPA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAwPF;;AArPA;EACE;IACE,UAAA;EAwPF;EArPA;IACE,UAAA;EAuPF;EApPA;IACE,UAAA;EAsPF;AACF;AA9OE;EACE,gBAAA;AAgPJ;AA3OI;EACE,SAAA;AA6ON;;AAvOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AA0OF;AAxOE;EACE,yBAAA;AA0OJ;AAvOE;EACE,oCAAA;AAyOJ;AArOI;EACE,mCAAA;AAuON;AApOI;EACE,UAAA;AAsON;AAjOI;EACE,0BAAA;AAmON;AA/NE;EACE,kBAAA;EACA,gBAAA;AAiOJ;AA9NE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAgOJ;AA9NI;EALF;IAMI,YAAA;IACA,iBAAA;EAiOJ;AACF;AA/NI;EACE,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AAiON;AA/NM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAiOR;AA/NQ;EACE,aAAA;AAiOV;AA7NM;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AA+NR;AA5NM;EACE,4BAAA;EACA,kBAAA;AA8NR;AAxNgB;EACE,iBAAA;AA0NlB;AAxNkB;EACE,gBAAA;AA0NpB;AArNc;EACE,aAAA;AAuNhB;AApNc;EACE,eAAA;EACA,mBAAA;AAsNhB;AApNgB;EAGE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAoNlB;AAhNc;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAkNhB;AA9MgB;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AAgNlB;AA9MkB;EACE,yBAAA;EACA,qBAAA;AAgNpB;AAxMQ;EACE,UAAA;AA0MV;AApME;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AAsMJ;AApMI;EACE,qBAAA;EACA,yBAAA;AAsMN;AAnMI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAqMN;AAnMM;EACE,qBAAA;EACA,yBAAA;AAqMR;AAjMI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAmMN;AAjMM;EACE,qBAAA;EACA,yBAAA;AAmMR;AA/LI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAiMN;AA/LM;EACE,qBAAA;EACA,yBAAA;AAiMR;AA5LE;EACE,aAAA;AA8LJ;;AA1LA;EACE,gBAAA;AA6LF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","$assets: 'https://assets.foursightonline.com/app';\n@import './../../../../assets/styles/variables';\n\nbody.fs-skin {}\n\n.paypal img {\n  height: auto;\n  max-width: 100%;\n  cursor: pointer;\n}\n\n.btn-primary.btn-outline {\n  color: #fff;\n}\n\n.cart-product-imitation {\n  padding-top: 0;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n#price {\n  margin: 10px 0 0;\n\n}\n\ninput#check {\n  margin: 0 0 10px 0;\n}\n\ninput#check:focus {\n  outline: 0 none;\n  border: 1px solid $develop-color;\n}\n\nh5.add-new-card {\n  cursor: pointer;\n}\n\ninput.coupon-code {\n  height: 32px;\n  padding: 3px 7px;\n  display: inline-block;\n  line-height: normal;\n  border-radius: 3px;\n  font-size: 13px;\n  border: 1px solid #d0d0d0;\n  border-top: 1px solid #bbb;\n  width: 15em !important;\n  margin-right: 5px;\n\n  &:focus-visible,\n  &:focus {\n    outline: none;\n  }\n}\n\n.discount-form {\n  margin: 20px;\n}\n\n.discount-code {\n  color: $develop-color;\n  font-size: 15px;\n  font-weight: 500;\n\n  .fa {\n    padding-left: 2px;\n    color: #a5a6a9;\n    cursor: pointer;\n  }\n}\n\n.item-link {\n  cursor: pointer;\n}\n\n.label-shipping {\n  width: 100%;\n  display: block;\n  clear: both;\n  margin: 0;\n  padding: 10px 0px;\n  line-height: 1 !important;\n  vertical-align: top;\n  font-weight: normal;\n\n  &:first-child {\n    padding-top: 15px;\n  }\n\n  &:last-child {\n    padding-bottom: 15px;\n  }\n}\n\n.label-shipping input {\n  display: inline-block !important;\n  width: auto !important;\n  vertical-align: top !important;\n  margin: 0 !important;\n  line-height: normal;\n  height: auto !important;\n}\n\n.ibox-content {\n  &.margin-input {\n    .form-control {\n      margin-bottom: 15px;\n    }\n  }\n}\n\n/* iCheck plugin Square skin, green\n----------------------------------- */\n::ng-deep .ibox-content {\n\n\n  .icheckbox_square-green,\n  .iradio_square-green {\n    display: inline-block;\n    *display: inline;\n    vertical-align: middle;\n    margin: 0;\n    padding: 0;\n    width: 22px;\n    height: 22px;\n    background: url($assets+'/images/green.png') no-repeat;\n    border: none;\n    cursor: pointer;\n  }\n\n  .icheckbox_square-green {\n    background-position: 0 0;\n  }\n\n  .icheckbox_square-green.hover {\n    background-position: -24px 0;\n  }\n\n  .icheckbox_square-green.checked {\n    background-position: -48px 0;\n  }\n\n  .icheckbox_square-green.disabled {\n    background-position: -72px 0;\n    cursor: default;\n  }\n\n  .icheckbox_square-green.checked.disabled {\n    background-position: -96px 0;\n  }\n\n  .iradio_square-green {\n    background-position: -120px 0;\n  }\n\n  .iradio_square-green.hover {\n    background-position: -144px 0;\n  }\n\n  .iradio_square-green.checked {\n    background-position: -168px 0;\n  }\n\n  .iradio_square-green.disabled {\n    background-position: -192px 0;\n    cursor: default;\n  }\n\n  .iradio_square-green.checked.disabled {\n    background-position: -216px 0;\n  }\n\n  /* HiDPI support */\n  @media (-o-min-device-pixel-ratio: 5/4),\n  (-webkit-min-device-pixel-ratio: 1.25),\n  (min-resolution: 120dpi) {\n\n    .icheckbox_square-green,\n    .iradio_square-green {\n      background-image: url($assets+'/images/green@2x.png');\n      -webkit-background-size: 240px 24px;\n      background-size: 240px 24px;\n    }\n  }\n}\n\nspan.d-inline {\n  display: inline-block;\n  vertical-align: middle;\n  padding-right: 15px;\n  font-size: 14px !important;\n\n  input {\n    display: inline-block;\n    width: 70px;\n    font: inherit;\n\n    &:focus-visible {\n      outline: none;\n    }\n\n    &:focus {\n      border: 1px solid #1ab394;\n    }\n  }\n\n  h4 {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n}\n\n.shoping-cart-table {\n  td {\n    &:last-child {\n      width: 150px;\n    }\n  }\n}\n\n.ibox-title.bottom-border {\n  padding-left: 0;\n  padding-right: 0;\n  border-top: 0;\n  padding-top: 0;\n  min-height: inherit;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 20px;\n}\n\n.ibox-main {\n\n  select,\n  input {\n    margin-bottom: 10px;\n    margin-top: 2px;\n  }\n}\n\n.d-flex {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n  align-items: flex-end;\n  -webkit-align-items: flex-end;\n  -moz-align-items: flex-end;\n  width: 100%;\n}\n\n.d-flex-center {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n  align-items: center;\n  -webkit-align-items: center;\n  -moz-align-items: center;\n}\n\n.btn-top-bar {\n  text-align: right;\n}\n\n@media screen and (max-width: 597px) {\n  .btn-top-bar {\n    margin-top: 15px;\n    text-align: left;\n  }\n\n}\n\ntable.shoping-cart-table {\n  tr {\n    .desc {\n      width: 56%;\n      white-space: normal;\n\n      @media screen and (max-width: 640px) {\n        white-space: nowrap;\n      }\n\n    }\n\n    .img-td {\n      width: 14%;\n    }\n\n    .prc,\n    .qty,\n    .tlp {\n      width: 10%;\n      white-space: nowrap;\n      text-align: center;\n    }\n\n    .tlp {\n      text-align: right;\n    }\n\n    td.qty {\n      padding-top: 0;\n    }\n\n  }\n}\n\n.content-table {\n  padding: 15px 20px 0 20px;\n  background-color: #fff;\n}\n\n.shoping-cart-table.top-heading-table {\n  th {\n    border-bottom: 0;\n  }\n}\n\n::ng-deep.box-shadow-cart {\n  box-shadow: 0 0 10px -5px #000;\n  border-color: #e2e2e2;\n\n  .bottom-cart {\n    box-shadow: none;\n  }\n}\n\n.shipping-inline {\n  display: table;\n  width: 100%;\n\n  .label-shipping {\n    display: block;\n    vertical-align: top;\n    padding-right: 10px;\n    width: auto !important;\n\n    &:first-child {\n      padding-top: 10px;\n    }\n  }\n}\n\n.item-checkbox {\n  input[type=\"checkbox\"] {\n    margin-right: 5px;\n    margin-bottom: 5px;\n    vertical-align: middle;\n  }\n}\n\n.address-item {\n  .fa-pencil {\n    cursor: pointer;\n  }\n}\n\n.edit-address-form {\n  label {\n    margin-bottom: 0;\n    font-weight: 700;\n  }\n}\n\n\n// card container\n\n.main-card {\n  // background: #EEE;\n  position: relative;\n  padding: 30px;\n  // max-width: 400px;\n  width: 100%;\n  margin: 0 auto;\n\n  input:focus {\n    outline: none;\n  }\n}\n\n.slds-form--compound .slds-form-element,\n.slds-form_compound .slds-form-element {\n  width: 100%;\n}\n\n.slds-form-element {\n  position: relative;\n}\n\n.slds-form--compound .slds-form-element__row,\n.slds-form_compound .slds-form-element__row {\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: .5rem;\n}\n\n.slds-form--compound .slds-form-element,\n.slds-form_compound .slds-form-element {\n  width: 100%;\n}\n\n.slds-input,\n.slds-button {\n  border-radius: 0;\n}\n\n.slds-input {\n  background-color: #fff;\n  color: #16325c;\n  border: 1px solid #d8dde6;\n  border-radius: .25rem;\n  width: 100%;\n  transition: border .1s linear, background-color .1s linear;\n  display: inline-block;\n  padding: 0 1rem 0 .75rem;\n  line-height: 2.875rem;\n  min-height: calc(1.875rem + (1px * 2));\n}\n\n.slds-form--compound .slds-form-element__row+.slds-form-element__row,\n.slds-form_compound .slds-form-element__row+.slds-form-element__row {\n  clear: both;\n}\n\n.slds-size--1-of-2,\n.slds-size_1-of-2 {\n  width: 50%;\n}\n\n.slds-size--1-of-1,\n.slds-size_1-of-1 {\n  width: 100%;\n}\n\n.slds-button {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\n.slds-button {\n  position: relative;\n  display: inline-block;\n  padding: 0;\n  background: 0 0;\n  background-clip: border-box;\n  border: 1px solid transparent;\n  border-radius: .25rem;\n  font-size: 1.2rem;\n  line-height: 2.875rem;\n  text-decoration: none;\n  color: #0070d2;\n  -webkit-appearance: none;\n  white-space: normal;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  transition: color 50ms linear, background-color 50ms linear;\n}\n\n.slds-button--brand,\n.slds-button_brand {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  text-align: center;\n  vertical-align: middle;\n  background-color: $develop-color;\n  border: 1px solid $develop-color;\n  color: #fff;\n}\n\n.mt-card {\n  margin-top: 15px;\n}\n\n.bottom-cart select,\n.bottom-cart input {\n  margin-bottom: 16px;\n  margin-top: 1px;\n  min-height: 34px;\n\n  &:focus-visible {\n    outline: none;\n  }\n\n  &:focus {\n    border: 1px solid #1ab394;\n  }\n}\n\n.jp-card {\n  min-width: inherit;\n}\n\n@media screen and (max-width: 1199px) {\n  .main-card {\n    justify-content: center;\n    -webkit-justify-content: center;\n    -moz-justify-content: center;\n  }\n\n  .pd-top-card {\n    padding-top: 25px;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .shipping-inline {\n    display: block;\n\n    label {\n      display: block;\n    }\n  }\n}\n\n@media screen and (max-width: 480px) {\n  ::ng-deep.jp-card-container {\n    width: 100% !important;\n    margin-bottom: 10px;\n    transform: none !important;\n  }\n\n  ::ng-deep.jp-card {\n    min-width: inherit !important;\n    max-width: 400px;\n  }\n\n  .main-card {\n    padding: 15px;\n    display: block;\n  }\n\n  .item-checkbox {\n    float: left;\n    text-align: left;\n    clear: both;\n  }\n}\n\n.address-mb {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n.ibox-title.pdts {\n  border-bottom: 1px solid #ddd;\n}\n\n.address-form {\n  padding-top: 25px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.ship-methods,\n.card-payment {\n  min-height: 150px;\n  left: 0 !important;\n  top: 0 !important;\n  position: relative;\n}\n\n.ibox-title h5 {\n  cursor: pointer;\n}\n\n.main-wrapper {\n  margin-bottom: 30px;\n}\n\n.submain-wrapper {\n  margin-bottom: 20px;\n}\n\n.billing-lables {\n  display: block;\n  width: 100%;\n\n  label {\n    display: inline-block;\n    vertical-align: middle;\n    font-weight: normal;\n    padding-right: 10px;\n  }\n\n  input {\n    vertical-align: middle;\n    display: inline-block;\n    width: auto;\n    height: auto;\n  }\n}\n\n.address-item {\n  padding-top: 15px;\n  padding-bottom: 15px;\n\n  ul {\n    padding: 0;\n    margin-left: 0;\n    margin-bottom: 15px;\n  }\n}\n\n.add-shipping {\n  display: inline-block;\n  padding: 15px;\n  cursor: pointer;\n  background-color: #fff;\n  border: 1px dotted #ddd;\n  -moz-box-shadow: 0 2px 0 #ddd;\n  -webkit-box-shadow: 0 2px 0 #ddd;\n  box-shadow: 0 2px 0 #ddd;\n  white-space: wrap;\n  zoom: 1;\n  -moz-user-select: -moz-none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  margin: 0;\n  padding: 0;\n  border-radius: 5px;\n  -moz-border-radius: 5px;\n  -webkit-border-radius: 5px;\n  padding: 5px 10px 0px;\n  font-size: 14px;\n  line-height: 1.3;\n\n  &:hover {\n    border: 1px solid #ccc;\n  }\n\n  i {\n    font-size: 20px;\n    padding: 0 15px 0 0;\n    float: left;\n  }\n\n  span {\n    overflow: hidden;\n    display: inherit;\n    display: block;\n  }\n}\n\n.address-item {\n  .btn {\n    font-size: 12px;\n  }\n}\n\n.mb-same-billing {\n  margin-bottom: 10px;\n\n  label {\n    cursor: pointer;\n  }\n}\n\n.billing-box {\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n  margin-bottom: 20px;\n\n  @media screen and (max-width: 767px) {\n    display: block;\n  }\n}\n\n.saved-cards-wrap {\n  padding-top: 25px;\n  padding-left: 15px;\n  padding-right: 15px;\n\n  @media screen and (max-width: 767px) {\n    div[class*=\"col-\"]:nth-child(2) {\n      padding-top: 20px;\n    }\n  }\n}\n\n.saved-card-list {\n  li label {\n    padding-left: 15px;\n    padding-right: 10px;\n    cursor: pointer;\n  }\n\n  li i {\n    cursor: pointer;\n  }\n}\n\n.new-card {\n  label {\n    padding-left: 15px;\n  }\n}\n\n.label-shipping {\n  input {\n    float: left;\n    margin-top: 4px !important;\n  }\n\n  label {\n    float: left;\n    padding-left: 10px;\n    width: 80%;\n    cursor: pointer;\n    font-weight: normal;\n    line-height: 1.6;\n  }\n}\n\n.order-info {\n  font-weight: normal;\n  font-style: italic;\n}\n\n.list-ship-adrs {\n  display: block;\n  width: 100%;\n  position: relative;\n  padding-left: 24px;\n\n  input[type=\"radio\"] {\n    display: inline-block;\n    width: auto;\n    vertical-align: top;\n    height: auto;\n    margin-top: 5px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    min-height: inherit;\n  }\n\n  label {\n    display: inline;\n    padding-left: 0;\n    cursor: pointer;\n    vertical-align: middle;\n\n    @media screen and (max-width:540px) {\n      vertical-align: top;\n      width: 80%;\n    }\n\n    span {\n      vertical-align: middle;\n    }\n  }\n\n  a,\n  span {\n    vertical-align: middle;\n  }\n}\n\n.bill-adrs {\n  margin-bottom: 15px;\n}\n\n.label-shipAdrs {\n  font-weight: 400 !important;\n}\n\n.list-bold {\n  font-weight: bold;\n}\n\n.btn-address {\n  background-color: $color-neutral-dark;\n  color: white;\n  opacity: 0.6;\n}\n\n.btn-address.active {\n  background-color: $develop-color;\n  opacity: 1.0;\n}\n\n//swal\n::ng-deep.swal2-modal {\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -moz-justify-content: center;\n}\n\n::ng-deep .swal2-show {\n  background-color: white;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  width: 478px;\n  padding: 17px;\n  border-radius: 5px;\n  text-align: center;\n  position: fixed;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: -256px;\n  overflow: hidden;\n  z-index: 99999;\n  margin-top: -168px;\n\n  &:focus {\n    outline: none;\n  }\n\n  button.swal2-cancel.swal2-styled {\n    background-color: #D0D0D0 !important;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  button.swal2-confirm.swal2-styled {\n    background-color: #AEDEF4;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .swal2-icon.swal2-warning {\n    width: 80px;\n    height: 80px;\n    border: 4px solid gray;\n    -webkit-border-radius: 40px;\n    border-radius: 40px;\n    border-radius: 50%;\n    margin: 20px auto;\n    padding: 0;\n    position: relative;\n    box-sizing: content-box;\n    border-color: #F8BB86;\n    font-size: 58px;\n    color: #F8BB86;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -moz-justify-content: center;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  h2#swal2-title {\n    color: #575757;\n    font-size: 30px;\n    text-align: center;\n    font-weight: 600;\n    text-transform: none;\n    position: relative;\n    margin: 25px 0;\n    padding: 0;\n    line-height: 40px;\n    display: block;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  div#swal2-content {\n    color: #797979;\n    font-size: 16px;\n    text-align: center;\n    font-weight: 300;\n    position: relative;\n    text-align: inherit;\n    float: none;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n::ng-deep .swal2-shown {\n  background-color: black;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 99999;\n}\n\n::ng-deep.swal2-modal {\n  max-width: 500px !important;\n  width: 100% !important;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: 0 !important;\n  margin-top: 0 !important;\n  box-sizing: border-box !important;\n  bottom: 0;\n  right: 0;\n  margin: auto !important;\n  height: 390px;\n}\n\n@media screen and (max-width: 380px) {\n  ::ng-deep.swal2-modal {\n    height: inherit;\n  }\n}\n\n::ng-deep.swal2-icon-text {\n  font-size: 1.3em;\n  line-height: 1;\n}\n\n.fade-div {\n  opacity: 0.4;\n}\n\n.list-group {\n  .pull-left {\n    font-family: $muso-300;\n    font-size: 15px;\n    padding: 5px 0px;\n    width: 60%;\n\n    &--bold {\n      font-family: 'Museo-700' !important;\n    }\n  }\n\n  .pull-right {\n    font-size: 2em;\n\n    &--bold {\n      font-family: 'Museo-700' !important;\n    }\n  }\n\n}\n\n.list-group.clear-list .list-group-item.fist-item {\n  border-top: 1px solid #aaa;\n  border-bottom: 0;\n  border-right: 0;\n  border-left: 0;\n  padding: 10px 0;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\nli.list-group-item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  align-items: center;\n\n  &--discount {\n    margin-bottom: 50px !important;\n  }\n\n  &--none {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    align-items: center;\n    list-style: none !important;\n  }\n\n  &--total {\n    border-bottom: 1px solid #aaa !important;\n  }\n}\n\n.amount-span {\n  white-space: nowrap;\n  word-break: normal !important;\n  max-width: inherit;\n  width: 40%;\n  text-align: right;\n  font-size: 1em !important;\n  font-family: $muso-300 !important;\n\n  &--bold {\n    font-family: 'Museo-700' !important;\n  }\n}\n\n.d-inline {\n  display: inline-block;\n}\n\n.prod-options {\n  .btn-primary {\n    display: inline-block;\n  }\n}\n\n.complimentary-item {\n  position: relative;\n  padding-top: 8px;\n}\n\n.red-text {\n  color: red;\n}\n\n.error-msg {\n  font-size: 14px;\n}\n\n.payment-grid {\n  position: relative;\n}\n\n.fixed-loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n.main-card {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.assessment-title h2 {\n  margin-top: 0;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 1.3;\n  margin-bottom: 0;\n}\n\n#stripe_error {\n  color: #f00;\n}\n\n#card_error {\n  display: none;\n  color: white;\n  background-color: red;\n  padding: 10px;\n}\n\n#stripe_card {\n  background: #f2f2f2;\n  padding: 20px;\n  // margin: 17px 0 20px;\n  margin-bottom: 5px !important;\n  border-radius: 2px;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n}\n\n.ship-methods {\n  padding: 15px;\n}\n\n.list-summary {\n  clear: both;\n  display: block;\n}\n\n.ship-methods-heading {\n  padding-left: 14px;\n}\n\n.billing-header {\n  margin-top: 20px;\n  margin-bottom: 0 !important;\n}\n\n.summary-product-name {\n  font-size: 13px;\n  display: block;\n  margin: 2px 0 5px 0;\n}\n\n.top-cart h5 {\n  @include headingfont();\n}\n\n.summary-product-quantity {\n  font-size: 13px;\n  display: block;\n}\n\n/*@media screen and (min-width:1101px) and (max-width:1300px){\n    .amount-span{\n        font-size: 1.5em !important;\n    }\n}\n@media screen and (min-width:992px) and (max-width:1100px){\n.amount-span{\n        font-size: 1.2em !important;\n}   \n}\n@media screen and (max-width:575px){\n .amount-span{\n        font-size: 1.2em !important;\n}      \n}*/\n\n.span12 {\n  padding-top: 15px;\n}\n\n.billing-details {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding-top: 10px;\n\n  @media screen and (max-width:400px) {\n    display: block;\n  }\n\n  h5 {\n    margin-top: 3px;\n  }\n}\n\n.billing-details .item-checkbox {\n  padding-left: 10px;\n\n  @media screen and (max-width:400px) {\n    padding-left: 0;\n  }\n}\n\n@media screen and (max-width:767px) {\n  .shipping-adrs .address-form {\n    padding-top: 0 !important;\n  }\n\n  .shipping-adrs.bottom-cart {\n    padding-top: 0 !important;\n  }\n}\n\n.empty-cart {\n  padding: 17px;\n  font-size: 2rem;\n  font-weight: 600;\n\n  a {\n    margin-left: 10px;\n  }\n}\n\n\n/*modal tab*/\n.tab {\n  display: table;\n  width: 100%;\n  padding-left: 0px;\n  margin-bottom: 0;\n  border: 1px solid #ddd;\n  text-align: center;\n\n  li {\n    display: table-cell;\n    padding: 5px 10px;\n    cursor: pointer;\n    font-weight: 600;\n    vertical-align: middle;\n    background-color: rgba(0, 0, 0, .07);\n\n    &.active-block {\n      background-color: #fff;\n    }\n\n    &+li {\n      border-left: 1px solid #ddd;\n    }\n\n    img {\n      margin-right: 5px;\n      vertical-align: middle;\n    }\n  }\n}\n\n.note-block {\n  margin-top: 20px;\n  background: #f5f5f5;\n  padding: 15px;\n\n  strong {\n    font-size: 16px;\n    margin-bottom: 10px;\n    display: inline-block;\n  }\n\n  ol {\n    padding-left: 25px !important;\n\n    li+li {\n      margin-top: 10px;\n    }\n  }\n}\n\n.tab-content {\n  .tab-content-inner {\n    padding-top: 20px;\n  }\n\n  .pt-2 {\n    padding-top: 20px;\n  }\n\n  h2 {\n    margin: 0 0 5px;\n    line-height: 32px;\n    font-size: 20px;\n    font-weight: 400;\n  }\n\n  ol {\n    padding-left: 15px;\n  }\n\n  .orange-btn {\n    padding: 12px 20px;\n    background-color: rgb(226, 95, 31);\n    color: #fff;\n    text-transform: capitalize;\n    display: inline-block;\n    border-radius: 3px;\n  }\n}\n\n.modal-body {\n  padding-top: 30px;\n\n  button.close {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n  }\n\n}\n\n::ng-deep.grey {\n  background: rgba(236, 236, 236, 0.9);\n}\n\n\n.tooltipicon {\n  position: relative;\n  cursor: pointer;\n  // margin-top: 12px;\n  font-size: 11px;\n}\n\n.tooltipicon .tooltiptext {\n  visibility: hidden;\n  width: 250px;\n  background-color: #fff;\n  color: #676a6c;\n  text-align: left;\n  border-radius: 6px;\n  padding: 10px;\n  box-shadow: 0 0 18px rgba(0, 0, 0, .1);\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 15px;\n  line-height: 1.2em;\n  /* Position the tooltip */\n  position: absolute;\n  top: 15px;\n  right: 10px;\n  z-index: 1;\n\n  @media screen and (max-width:1199px) {\n    left: auto;\n    right: 10px;\n  }\n}\n\n.tooltipicon:hover .tooltiptext {\n  visibility: visible;\n}\n\n.bottom-card {\n  // margin-top: 20px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.ibox-title h5 {\n  @include headingfont();\n}\n\nbutton.close {\n  z-index: 999999;\n}\n\n.grey-out {\n  background: $body-content-color;\n  border-color: $body-content-color;\n  opacity: 0.5;\n}\n\n::ng-deep.card-payment {\n  z-index: 99999999 !important;\n\n  .modal-dialog {\n    max-width: 400px !important;\n\n    .modal-body {\n      padding: 0 !important;\n    }\n  }\n\n\n}\n\n.proceed-ship-method {\n  padding: 10px;\n}\n\n.sr-form-row {\n\n  label {\n    padding-top: 5px;\n    margin-bottom: 0;\n    font-weight: 700;\n    padding-left: 22px;\n\n    input {\n      top: 8px;\n      left: 0;\n    }\n  }\n}\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100%;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: .5s;\n  opacity: 0;\n}\n\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n\n}\n\n// \n\n.table-responsive {\n\n  table {\n    margin-bottom: 0;\n  }\n\n  tr {\n\n    td {\n      border: 0;\n    }\n  }\n}\n\n// Modal Design\n::ng-deep .modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n\n  &.show {\n    display: block !important;\n  }\n\n  &.grey {\n    background: rgba(236, 236, 236, 0.9);\n  }\n\n  &.fade {\n    .modal-dialog {\n      transition: transform 0.3s ease-out;\n    }\n\n    &.in {\n      opacity: 1;\n    }\n  }\n\n  &.in {\n    .modal-dialog {\n      transform: translate(0, 0);\n    }\n  }\n\n  &.modal-open {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px;\n\n    @media (min-width: 768px) {\n      width: 600px;\n      margin: 30px auto;\n    }\n\n    .modal-content {\n      background-clip: padding-box;\n      background-color: #FFFFFF;\n      border: 1px solid rgba(0, 0, 0, 0);\n      border-radius: 4px;\n      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n      outline: 0 none;\n      position: relative;\n\n      .close {\n        float: right;\n        font-size: 21px;\n        font-weight: bold;\n        line-height: 1;\n        color: #000;\n        text-shadow: 0 1px 0 #fff;\n        filter: alpha(opacity=20);\n        opacity: 0.2;\n\n        &:focus-visible {\n          outline: none;\n        }\n      }\n\n      button.close {\n        padding: 0;\n        cursor: pointer;\n        background: transparent;\n        border: 0;\n        -webkit-appearance: none;\n        appearance: none;\n      }\n\n      .modal-body {\n        padding: 20px 30px 30px 30px;\n        position: relative;\n\n        .rw {\n          &__cl {\n            form {\n              .table-responsive {\n                table {\n                  line-height: 20px;\n\n                  th {\n                    text-align: left;\n                  }\n                }\n              }\n\n              ul {\n                margin-top: 0;\n              }\n\n              .list-group {\n                padding-left: 0;\n                margin-bottom: 20px;\n\n                &-item.active,\n                &-item.active:hover,\n                &-item.active:focus {\n                  z-index: 2;\n                  color: #fff;\n                  background-color: #337ab7;\n                  border-color: #337ab7;\n                  border-radius: 4px;\n                }\n              }\n\n              .lbl {\n                display: inline-block;\n                max-width: 100%;\n                margin-bottom: 5px;\n                font-weight: 700;\n              }\n\n              .btn-r {\n                .f-btn {\n                  padding: 5px 10px;\n                  line-height: 1.5;\n                  font-size: 12px;\n\n                  &--info {\n                    background-color: #1dc5a3;\n                    border-color: #1dc5a3;\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        &.no-pad {\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  .f-btn {\n    color: #fff;\n    font-size: 14px;\n    border-color: #73BF38;\n    background-color: #73BF38;\n\n    &:hover {\n      border-color: #4cae4c;\n      background-color: #4cae4c;\n    }\n\n    &--dngr {\n      color: #fff;\n      border-color: #ED5565;\n      background-color: #ED5565;\n\n      &:hover {\n        border-color: #ec4758;\n        background-color: #ec4758;\n      }\n    }\n\n    &--info {\n      color: #fff;\n      border-color: #23c6c8;\n      background-color: #23c6c8;\n\n      &:hover {\n        border-color: #21b9bb;\n        background-color: #21b9bb;\n      }\n    }\n\n    &--wrng {\n      color: #fff;\n      border-color: #f8ac59;\n      background-color: #f8ac59;\n\n      &:hover {\n        border-color: #f7a54a;\n        background-color: #f7a54a;\n      }\n    }\n  }\n\n  .hidden {\n    display: none;\n  }\n}\n\n::ng-deep.modal-open {\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
